{
	"title": "Welcome to StudyHub",
	"skip": "Skip",
	"back": "Back",
	"next": "Next",
	"saving": "Saving…",
	"stepProgress": "Step {current} of {total}",
	"language": {
		"title": "Choose your language",
		"subtitle": "Interface language. You can change it later in settings.",
		"uiLanguageLabel": "Interface language",
		"uiLanguagePlaceholder": "Choose a language…",
		"continue": "Continue"
	},
	"method": {
		"title": "How studying works here",
		"lead": "The unit of learning is a topic, not a file. Every topic follows the same route of three steps.",
		"step1": {
			"body": "Notes, audio, a diagram or a glossary — so the structure of the topic becomes visible. This step is short: memorising does not happen here."
		},
		"step2": {
			"body": "Flashcards and a quiz where the answer has to be retrieved from memory. Before answering you mark how confident you are — a confident mistake is reviewed first."
		},
		"step3": {
			"body": "The check shows not a grade but the exact places where the answer did not come together. Work continues with those: by voice, with cards, in discussion."
		},
		"science": "The order is built around techniques that reviews of study methods rate as the most useful.",
		"link": "More about the method"
	},
	"firstCourse": {
		"title": "Where do we start",
		"lead": "Build a course on a topic, take a ready-made one from the catalog, or start with an empty space for your own materials. None of the three needs your files.",
		"cta": "Create your first course",
		"skip": "Skip — I'll come back later"
	},
	"rhythm": {
		"title": "How much time a day",
		"lead": "We will build a calendar plan across all your materials from this: topics, reviews and deadlines laid out by day. Miss a session and the plan rebuilds itself.",
		"minutesLabel": "Minutes a day",
		"minutesCustom": "Custom",
		"daysLabel": "Study days",
		"hint": "You can change this at any time in settings.",
		"saveFailed": "Could not save your study rhythm",
		"goalFailed": "The calendar is set, but the daily goal could not be saved",
		"minutesHint": "How much time you're ready to spend studying on a normal day. The plan won't schedule more.",
		"daysHint": "Which weekdays to schedule sessions on. Other days stay free."
	},
	"done": {
		"title": "All set",
		"lead": "Next: upload your materials, build your own course, or start a course from the catalog.",
		"cta": "Go to home"
	},
	"howItWorks": {
		"title": "How it works",
		"tabs": {
			"method": "Method",
			"course": "Building a course",
			"tools": "Tools"
		},
		"tools": {
			"lead": "Tools are grouped by what you do: read, watch, listen, practise, plan."
		},
		"link": "More about the method"
	}
}
